import { render, staticRenderFns } from "./AdditionalCharges.vue?vue&type=template&id=3b8e445a&scoped=true"
import script from "./AdditionalCharges.vue?vue&type=script&lang=js"
export * from "./AdditionalCharges.vue?vue&type=script&lang=js"
import style0 from "./AdditionalCharges.vue?vue&type=style&index=0&id=3b8e445a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e445a",
  null
  
)

export default component.exports